const TermsAndConditions = ({ agreed, setAgreed }) => {
  return (
    <div>
      <section
        id="about-us-section"
        className="about-us-section py-4 px-5"
        style={{ fontSize: "0.65rem" }}
      >
        <div className="container" style={{ width: "100%" }}>
          <div className="row">
            <div className="col-md-12 text-center">
              <img
                src="./images/shopping-list.png"
                style={{ width: "90px" }}
                alt=""
              />
            </div>
            {/* <div className="col-md-1"></div> */}
            <div className="col-md-12">
              <h3 className="text-center" style={{color:"blue"}}>
                <b className="border-b">Terms and Conditions</b>
              </h3>

              <p className="text-16 text-black text-justify">
                <strong>License and Access - </strong>
                DocMaster grants you a limited license to access and use website
                subject to the Terms, as applicable from time to time. The
                website and any portion thereof should not be reproduced,
                duplicated, copied, downloaded, sold, resold, visited, or
                otherwise exploited for any commercial purpose without the
                express written consent of DocMaster. Any unauthorized use
                terminates the license granted by DocMaster.
              </p>
              <p className="text-16 text-black text-justify">
                <strong>Limitation of Liability - </strong>
                The website is for use of "As is" and "As available" basis.
                DocMaster makes no representations or warranties of any kind,
                express or implied otherwise stated, as to the operation of this
                site, or the information, content or materials included on this
                site. You expressly agree that your use of this site is at your
                sole choice.
              </p>
              <p className="text-16 text-black text-justify">
                <strong>Acceptable use - </strong>
                You agree to use the services of DocMaster for lawful, personal
                or professional use of yourself or particular client (as the
                case may be) only and not for any prohibited purpose. Prohibited
                purpose includes but shall not be limited to harass abuse or
                threaten any other persons, Violate any person’s legal rights,
                Violate any Intellectual Property Rights of DocMaster or any
                third party, Publish or distribute any obscene or defamatory
                matter on the website, Perpetrate any fraud and any other act
                prohibited by the law.
              </p>

              <p className="text-16 text-black text-justify">
                <strong> Binding Effect - </strong>
                This Agreement shall be binding upon and shall ensure to the
                benefit of each Party and to its respective successors or
                permitted assigns.
              </p>
              <p className="text-16 text-black text-justify">
                <strong> Severability - </strong>
                The invalidity or unenforceability of any provision of this
                Agreement shall not affect the validity or enforceability of any
                other provision.
              </p>
              <p className="text-16 text-black text-justify">
                <strong> Voluntary Execution of Agreement - </strong>
                The user acknowledges that they have read this terms and
                documents and voluntarily in agreement without duress and full
                knowledge of their legal significance and understands the
                consequences of further changes with its software releases at
                later stages and fully aware of the legal and binding effect of
                this agreement.
              </p>

              <p className="text-16 text-black text-justify">
                <strong> Governing Language - </strong>
                This Agreement has been executed in the English language, which
                shall be the official language for the construction and
                interpretation of this Agreement and all notices, agreements,
                documents, and instruments contemplated hereunder, and the
                medium of communication thereunder. This Agreement may be
                translated into any language other than English provided,
                however, that the English version shall always prevail.
              </p>
              <p className="text-16 text-black text-justify">
                {" "}
                <strong> Governing Law and Dispute Settlement - </strong>
                This Agreement shall be governed by and construed in accordance
                with the laws of the India. Any dispute arising out of or in
                connection with this Agreement shall be finally settled by the
                competent courts of New Delhi, India.
              </p>
              <p className="text-16 text-black text-justify">
                <strong>No Legal Relationship - </strong> Nothing in this
                Agreement shall be construed to create an employer- employee,
                lawyer-client or any such relationship between user of the
                Website and DocMaster.
              </p>
            </div>
          </div>
        </div>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.85rem",
          }}
        >
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="me-2"
          />
          I Agree
        </label>
      </section>
    </div>
  );
};

export default TermsAndConditions;
